import { X } from 'lucide-react';
import { SeatsioSeatingChart } from '@seatsio/seatsio-react';
import { Trans, t } from '@lingui/macro';
import { useLingui } from '@lingui/react';

const CHART_HEIGHT = 'calc(100vh - 112px)';

const BAR_BORDER = 'rgb(38, 43, 49)';

export default function SeatmapPreviewModal({ open, onClose, event }) {
    const { i18n } = useLingui();

    if (!open) {
        return null;
    }

    return (
        <div
            className="fixed inset-0 z-[10000] flex flex-col bg-background text-foreground"
            role="dialog"
            aria-modal="true"
            aria-labelledby="checkout-modal-title"
        >
            <header
                className="sticky top-0 z-[1] min-h-14 border-b sm:min-h-16"
                style={{ backgroundColor: 'hsl(var(--card))', borderColor: BAR_BORDER }}
            >
                <div className="mx-auto flex h-full min-h-14 w-full max-w-screen-xl items-center justify-between gap-3 px-0 sm:min-h-16 sm:pr-2">
                    <button
                        type="button"
                        onClick={onClose}
                        className="inline-flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-md border-0 bg-transparent text-foreground transition-colors hover:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                        aria-label={t`Close checkout`}
                    >
                        <X className="h-6 w-6" aria-hidden />
                    </button>
                </div>
            </header>

            <div className="h-px w-full shrink-0 bg-[rgba(255,255,255,0.12)]" aria-hidden />

            <div
                className="sticky top-14 z-[1] border-b py-2 sm:top-16"
                style={{ backgroundColor: 'hsl(var(--card))', borderColor: BAR_BORDER }}
            >
                <div className="mx-auto flex w-full max-w-screen-xl justify-center items-center px-2 text-center">
                    <Trans>
                        This is a preview. Please check back later when tickets are on sale.
                    </Trans>
                </div>
            </div>

            <div className="checkout-modal-scrollbar min-h-0 flex-1 overflow-auto">
                <div className="w-full select-none bg-background" style={{ height: CHART_HEIGHT }}>
                    <SeatsioSeatingChart
                        workspaceKey={event.seatsPublicKey}
                        event={event.seatsEventKey}
                        region="na"
                        showFullScreenButton={false}
                        maxSelectedObjects={0}
                        language={i18n.locale}
                        colorScheme="dark"
                    />
                </div>
            </div>
        </div>
    );
}
